import * as React from "react";
import { Box, Button, Chip, IconButton, Stack, TextField, Tooltip, Typography } from "@mui/material";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { IUserMessage } from "../../../types/user-info/user-message";
import { IShowAlert, IUserInfo } from "../../../types/user-info/user-info";
import { useAppDispatch } from "../../../Hooks";
import { addUserMessage, setShowAllert } from "../../../store/user-process/user-process";
import { User } from "../../../types/user-info/user-request";
import { CreateMessage } from "../../../services/api-actions/personal-user-request-action";
import byteConverter from "../../../utils/byteConverter";
import { AlertType } from "../../../enums/enum";
import { brand } from "../../../theme";

export type MessageInputProps = {
  textAreaValue: string;
  setTextAreaValue: (value: string) => void;
  userInfo: IUserInfo;
  requestId: string;
};

export default function MessageInput(props: MessageInputProps) {
  const dispatch = useAppDispatch();
  const { textAreaValue, setTextAreaValue, userInfo, requestId } = props;
  const [file, setFile] = React.useState<File>();

  const handleClick = () => {
    if (textAreaValue.trim() !== "") {
      dispatch(
        CreateMessage({
          RequestId: requestId,
          Message: textAreaValue,
          File: file,
        })
      );
      dispatch(
        addUserMessage({
          createdDate: new Date(),
          message: textAreaValue,
          user: { fio: userInfo.fio, email: userInfo.email, id: userInfo.userId } as User,
          fileName: file?.name,
        } as IUserMessage)
      );
      setTextAreaValue("");
      setFile(undefined);
    } else {
      dispatch(
        setShowAllert({
          open: true,
          message: "Введите текст сообщения для отправки",
          type: AlertType.error,
        } as IShowAlert)
      );
    }
  };

  const handleFileChange = (e: any) => {
    if (e.target.files[0] == undefined) return;
    if (e.target.files[0].name.includes(".exe")) {
      dispatch(setShowAllert({ open: true, message: "Нельзя загружать файл тип .exe", type: AlertType.error } as IShowAlert));
      return;
    }
    if (Number(byteConverter(e.target.files[0].size, 2, "MB").replace("MB", "")) > 15) {
      dispatch(setShowAllert({ open: true, message: "Загружаемый файл должен быть меньше 15 MB", type: AlertType.error } as IShowAlert));
      return;
    }
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  return (
    <Box sx={{ p: 2, borderTop: `1px solid ${brand.line}`, bgcolor: "#fff", borderBottomLeftRadius: 16, borderBottomRightRadius: 16 }}>
      {file != undefined && (
        <Chip
          label={file.name}
          onDelete={() => setFile(undefined)}
          icon={<AttachFileIcon />}
          sx={{ mb: 1.5, maxWidth: "100%", bgcolor: brand.background }}
        />
      )}
      <Stack direction="row" gap={1} alignItems="flex-end">
        <Tooltip title="Прикрепить файл (до 15 МБ)">
          <IconButton component="label" sx={{ border: `1px solid ${brand.line}`, borderRadius: 2, mb: 0.25 }} aria-label="Прикрепить файл">
            <AttachFileIcon />
            <input type="file" hidden onChange={(e) => handleFileChange(e)} />
          </IconButton>
        </Tooltip>
        <TextField
          placeholder="Введите сообщение…"
          aria-label="сообщение"
          multiline
          minRows={1}
          maxRows={8}
          fullWidth
          value={textAreaValue}
          onChange={(e) => setTextAreaValue(e.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
              handleClick();
            }
          }}
        />
        <Button variant="contained" onClick={handleClick} endIcon={<SendRoundedIcon />} sx={{ flexShrink: 0, mb: 0.25 }}>
          Отправить
        </Button>
      </Stack>
      <Typography sx={{ mt: 1, fontSize: 12.5, color: brand.muted }}>Ctrl + Enter — отправить сообщение</Typography>
    </Box>
  );
}
